import React from 'react';
import { connect } from 'react-redux';
import { Typography } from '@americanexpress/aqx-components';
import CardHighlights from './CardHighlights';
import DynAppBanner from './DynAppBanner';
import OfferBox from './OfferBox';
import TncLinksShared from 'src/universal/components/Tncs';
import { getCombinedG163Data } from './redux';
import styles from './__styles__/index.scss?modules';

const HeaderBox = ({ header, fee }) => {
  return (
    <div className={styles.headerBox}>
      <Typography Component="h1" className={styles.header}>
        {header}
      </Typography>
      <Typography Component="span" className={styles.fee}>
        {fee}
      </Typography>
    </div>
  );
};

const TncBox = ({ currCard }) => {
  return (
    <div className={styles.tncBox}>
      <TncLinksShared shortName={currCard.shortName} />
    </div>
  );
};

const SeamlessCampaignHero = ({ staticG163Data, currCard, pageData }) => {
  const { assets = [] } = staticG163Data;
  const backImgUrl = assets[0].url;
  const labelList = pageData?.labels || [];
  const annualFeeLabel = labelList.find(l => l.identifier === 'annualFee') || {};
  const headerProps = {
    header: currCard?.cardTitle,
    fee: `${annualFeeLabel.text} ${currCard?.annualFee}`
  };
  return (
    <>
      <div
        className={styles.seamlessCampaignHero}
        style={{ backgroundImage: `url(${backImgUrl})` }}
      >
        <HeaderBox {...headerProps} />
        <CardHighlights />
        <DynAppBanner />
        <TncBox currCard={currCard} />
      </div>
      <OfferBox />
    </>
  );
};

const mapStateToProps = state => {
  return {
    ...getCombinedG163Data(state)
  };
};

export default connect(mapStateToProps)(React.memo(SeamlessCampaignHero));
